import React, { useEffect, useState } from 'react';
import AdminApi from './AdminApi';
import { FILE_URL } from './Constants';
import TintucPageApi from './TintucPageApi';

const AdminNhacPhatGiaoPage = ({ clickChangeMenu, changeCurrentPostId, openCategoryPage }) => {
    const postType = 24;
    const pageTitle = 'Nhạc Phật giáo';

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [deletePostId, setDeletePostId] = useState(null);
    const [danhmuc, setDanhmuc] = useState([]);
    const [catId, setCatId] = useState(null);
    const [titleSearch, setTitleSearch] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');

    const callApi = (page, categoryId, search) => {
        AdminApi.getListTinTucAdmin(page, postType, categoryId, search).then((data) => {
            setTotalPages(data.totalPages);
            setTotalRecords(data.totalRecords);
            setData(data.data);
        });
        TintucPageApi.getAllType(postType).then((data) => {
            setDanhmuc(data);
        }).catch((error) => {
            console.error("Failed to fetch categories:", error);
        });
    };

    const formatDate = (isoDateString) => {
        const date = new Date(isoDateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const ampm = hours >= 12 ? 'CH' : 'SA';
        hours = hours % 12 || 12;
        hours = String(hours).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
    };

    const handlePageClick = (page) => {
        setCurrentPage(page);
    };

    const handleClickDeletePost = (postId) => {
        setShowConfirm(!showConfirm);
        setDeletePostId(postId);
    };

    const handleDeletePost = async () => {
        try {
            setIsLoading(true);
            await AdminApi.deleteNhacPhatGiaoPost(deletePostId);
            callApi(currentPage, catId, titleSearch);
        } catch (error) {
            console.error("Error deleting post:", error);
        } finally {
            setIsLoading(false);
            setShowConfirm(false);
        }
    };

    const handleEditPost = async (postId) => {
        clickChangeMenu('edit');
        changeCurrentPostId(postId);
    };

    const clickChangeCat = (e) => {
        const val = e.target.value;
        setCatId(val);
        setSelectedCategory(val);
        setCurrentPage(1);
        callApi(1, val, titleSearch);
    };

    const handleInputChange = (event) => {
        const val = event.target.value;
        setTitleSearch(val);
        setCurrentPage(1);
        callApi(1, catId, val);
    };

    useEffect(() => {
        callApi(currentPage, catId, titleSearch);
    }, [currentPage]);

    const columns = ['stt', 'title', 'categories', 'thumb', 'sort', 'author', 'date_create', 'active', 'is_new', 'actions'];

    const columnDefinitions = {
        stt: { 
            label: 'STT', 
            width: '40px', 
            align: 'center', 
            render: (item, index) => {
                if (typeof index === 'string') return ''; // Child row
                return (currentPage - 1) * 15 + index + 1;
            }
        },
        thumb: {
            label: 'Hình ảnh', width: '80px', render: (item) => (
                item.level === 1 && item.thumb ? (
                    <img
                        src={FILE_URL + item.thumb}
                        alt=""
                        style={{ width: '60px', height: '45px', objectFit: 'cover', borderRadius: '3px' }}
                    />
                ) : item.level === 1 ? <span style={{ color: '#999', fontSize: '11px' }}>Chưa có</span> : null
            )
        },
        title: { label: 'Tiêu đề', render: (item) => <span style={item.level > 1 ? { paddingLeft: '20px' } : { fontWeight: 'bold' }}>{item.level > 1 ? '-- ' : ''}{item.title}</span> },
        categories: { label: 'Chuyên mục', render: (item) => item.level === 1 ? item.categories : null },
        sort: { label: 'Thứ tự', width: '60px', align: 'center', render: (item) => item.level > 1 ? item.sort : null },
        author: { label: 'Tác giả', render: (item) => item.author || item.user_create },
        date_create: { label: 'Ngày tạo', width: '150px', render: (item) => item.date_create ? formatDate(item.date_create) : '' },
        active: { label: 'Kích hoạt', width: '60px', align: 'center', render: (item) => <input type="checkbox" checked={item.active} readOnly /> },
        is_new: { label: 'New', width: '40px', align: 'center', render: (item) => <input type="checkbox" checked={item.is_new} readOnly /> },
        actions: {
            label: 'Thao tác', width: '140px', render: (item) => (
                <div style={{ display: 'flex', gap: '5px' }}>
                    <a
                        onClick={() => handleEditPost(item.id)}
                        className="btn btn-success btn-small"
                        title="Sửa">
                        <i className="coloredicon page-white-edit" /> <strong>Sửa</strong>
                    </a>
                    <a
                        onClick={() => handleClickDeletePost(item.id)}
                        disabled={isLoading}
                        className="btn btn-danger btn-small delete-link"
                        title="Xóa">
                        <i className="coloredicon delete" /> <strong>Xóa</strong>
                    </a>
                </div>
            )
        }
    };

    return (
        <div>
            <div className="social-box">
                <h3 className="page-title">{pageTitle}</h3>
                <div className="header">
                    <div className="btn-group">
                        <a className="btn btn-primary"
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                clickChangeMenu("create");
                            }}>
                            <i className="icon-pencil" /> Tạo
                        </a>
                        <a className="btn" style={{ marginLeft: '5px' }}
                            href="#" onClick={e => {
                                e.preventDefault();
                                if (openCategoryPage) openCategoryPage(postType, pageTitle);
                            }}>
                            <i className="icon-folder-open" /> Chuyên mục
                        </a>
                    </div>
                </div>
                <div className="body">
                    <div>
                        <form method="get" action="#" style={{ display: 'inline-block', width: '50%' }} noValidate="novalidate">
                            <input type="text"
                                placeholder={`Nhập tên ${pageTitle}`}
                                className="form-control"
                                style={{
                                    display: 'inline-block',
                                    minWidth: '95%',
                                    height: '30px'
                                }}
                                value={titleSearch}
                                onChange={handleInputChange} />
                        </form>
                        <select
                            style={{
                                display: 'inline-block',
                                minWidth: '20%',
                                marginLeft: '20px',
                                height: '30px'
                            }}
                            value={selectedCategory}
                            onChange={clickChangeCat}
                        >
                            <option value="">-- Tất cả --</option>
                            {danhmuc?.map((item, index) => (
                                <option key={index} value={item.Id}>{item.Name}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <div className="table-container">
                <table cellPadding={0} cellSpacing={0} border={0} className="table table-hover">
                    <thead>
                        <tr>
                            {columns.map(col => (
                                <th key={col} width={columnDefinitions[col].width}>{columnDefinitions[col].label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <React.Fragment key={item.id}>
                                {/* Parent Row */}
                                <tr>
                                    {columns.map(col => (
                                        <td key={col} style={{ verticalAlign: 'middle', textAlign: columnDefinitions[col].align || 'left' }}>
                                            {columnDefinitions[col].render(item, index)}
                                        </td>
                                    ))}
                                </tr>
                                {/* Children Rows */}
                                {item.childrens && item.childrens.length > 0 && item.childrens.map((child, childIndex) => (
                                    <tr key={child.id} style={{ backgroundColor: '#fcfcfc' }}>
                                        {columns.map(col => (
                                            <td key={col} style={{ verticalAlign: 'middle', textAlign: columnDefinitions[col].align || 'left' }}>
                                                {columnDefinitions[col].render(child, index + '-' + childIndex)}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
                {isLoading && (
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <p>Deleting, please wait...</p>
                    </div>
                )}
                {showConfirm && (
                    <div className="modal-overlay1">
                        <div className="modal1">
                            <p>Bạn có chắc chắn muốn xóa bài viết này không?</p>
                            <div className="modal-actions1">
                                <button
                                    onClick={() => handleDeletePost()}
                                    disabled={isLoading}
                                    className="btn btn-danger"
                                >
                                    {isLoading ? "Đang xóa..." : "Xóa"}
                                </button>
                                <button
                                    onClick={() => handleClickDeletePost(null)}
                                    className="btn btn-secondary"
                                >
                                    Hủy
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div>
                <div style={{ fontWeight: 'bold', textAlign: 'center' }}>
                    Số lượng bản ghi: {totalRecords}
                </div>
                <div style={{ color: 'red' }}>
                    Đang xem trang {currentPage} (trong {totalPages} trang)
                </div>
                <div className="row" style={{ float: 'left', marginLeft: '5px' }}>
                    <div className="col-md-12 col-sm-12 col-xs-12"
                        style={{ paddingLeft: '0px' }}>
                        <div className="pagination-container">
                            <ul className="pagination">
                                {currentPage > 1 && (
                                    <>
                                        <li className="PagedList-skipToFirst">
                                            <a onClick={() => handlePageClick(1)}>««</a>
                                        </li>
                                        <li className="PagedList-skipToPrevious">
                                            <a onClick={() => handlePageClick(currentPage - 1)}>«</a>
                                        </li>
                                    </>
                                )}
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .slice(Math.max(0, currentPage - 5), Math.min(totalPages, currentPage + 4))
                                    .map((page) => (
                                        <li key={page} className={currentPage === page ? 'active' : ''}>
                                            <a onClick={() => handlePageClick(page)}>{page}</a>
                                        </li>
                                    ))}
                                {currentPage < totalPages && (
                                    <>
                                        <li className="PagedList-skipToNext">
                                            <a onClick={() => handlePageClick(currentPage + 1)}>»</a>
                                        </li>
                                        <li className="PagedList-skipToLast">
                                            <a onClick={() => handlePageClick(totalPages)}>»»</a>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminNhacPhatGiaoPage;
